export default __webpack_public_path__ + "static/media/aior3.a1fcf945.svg";